var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#fff",
    stroke: "#EBCE0E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.384 6C13.607 6 13 6.47 13 7.306c0 2.546.265 6.206.265 8.752 0 .664.513.942 1.12.942.455 0 1.1-.278 1.1-.942 0-2.546.265-6.206.265-8.752C15.75 6.47 15.124 6 14.384 6ZM14.51 19c-.863 0-1.51.682-1.51 1.5 0 .799.647 1.5 1.51 1.5.804 0 1.49-.701 1.49-1.5 0-.818-.686-1.5-1.49-1.5Z",
    fill: "#E9CB0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.384 6C13.607 6 13 6.47 13 7.306c0 2.546.265 6.206.265 8.752 0 .664.513.942 1.12.942.455 0 1.1-.278 1.1-.942 0-2.546.265-6.206.265-8.752C15.75 6.47 15.124 6 14.384 6ZM14.51 19c-.863 0-1.51.682-1.51 1.5 0 .799.647 1.5 1.51 1.5.804 0 1.49-.701 1.49-1.5 0-.818-.686-1.5-1.49-1.5Z",
    stroke: "#EACB00"
  })));
};
export default SvgWarning;